<template>
  <div class="container">
    <h4 class="mt-3">Registro de novo usuário</h4>
    <b-form @submit.prevent="register" v-if="showForm">
      <b-form-group id="input-group-username" label="Nome de Login:" label-for="input-username">
        <b-form-input id="input-username" v-model="username" required placeholder="Digite o login"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-fullName" label="Nome Completo:" label-for="input-fullName">
        <b-form-input
          id="input-fullName"
          v-model="fullName"
          required
          placeholder="Digite o Nome Completo"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-extraInfo"
        label="Informações Adicionais:"
        label-for="input-extraInfo"
      >
        <b-form-input
          id="input-extraInfo"
          v-model="extraInfo"
          placeholder="Gerência, Local, Finalidade, etc"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-email"
        label="Email:"
        label-for="input-email"
        description="O email será usado para avisar sobre novos relatórios relevantes, ou informar sobre instabilidades e manutenções."
      >
        <b-form-input
          id="input-email"
          v-model="email"
          type="email"
          required
          placeholder="Digite o email"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-password" label="Senha:" label-for="input-password">
        <b-form-input
          id="input-password"
          v-model="password"
          type="password"
          required
          placeholder="Digite a senha"
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-profile-id" label="Perfil de Acesso:" label-for="input-profile-id">
        <b-form-select id="input-profile-id" v-model="profileId" :options="getProfiles" required></b-form-select>
      </b-form-group>
      
      <b-alert v-model="successState" variant="success" dismissible>Usuário incluído com sucesso!</b-alert>
      <b-alert
        v-model="errorState"
        variant="danger"
        dismissible
      >{{errorMessage}}</b-alert>
      <b-button type="submit" variant="primary" class="mr-2 mb-2">
        <b-spinner v-if="loading" small class="mr-2"></b-spinner>Registrar
      </b-button>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      username: "",
      fullName: "",
      extraInfo: "",
      email: "",
      password: "",
      loading: false,
      errorState: false,
      successState: false,
      showForm: true,
      profileId: null,
      errorMessage: ""
    };
  },
  computed: {
    getProfiles(){
      var profiles = [{ value: null, text: '-- Selecione um Perfil de Acesso --', disabled: true }];
      this.$store.getters.getProfiles.forEach(profile => profiles.push({value: profile.id, text: profile.name}));
      return profiles;
    }
  },
  created(){
    this.$store.dispatch("retrieveProfiles");
  },
  methods: {
    register() {
      this.loading = true;
      this.$store
        .dispatch("register", {
          username: this.username,
          fullName: this.fullName,
          extraInfo: this.extraInfo,
          email: this.email,
          password: this.password,
          profileId: this.profileId
        })
        .then(() => {
          this.loading = false;
          this.errorState = false;
          this.successState = true;
          this.clearFiels();
        })
        .catch(error => {
          this.successState = false;
          this.loading = false;
          this.errorState = true;
          this.errorMessage = "Não foi possível incluir o novo usuário"
          console.log(error);
        });
    },
    clearFiels() {
      this.username = "";
      this.fullName = "";
      this.extraInfo = "";
      this.email = "";
      this.password = "";
      this.showForm = false;
      this.$nextTick(() => {
        this.showForm = true;
      });
    }
  }
};
</script>
